import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { leadLink } from "@/lib/roles";

const RB = `${process.env.REACT_APP_BACKEND_URL}/api/rcrm`;

// Top-bar lead search: name or phone from any CRM page → opens the lead card (Leads for managers, My Leads for callers).
export function LeadSearch() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [hi, setHi] = useState(0);
  const box = useRef(null);
  useEffect(() => {
    if (q.trim().length < 2) { setItems([]); return; }
    const t = setTimeout(async () => {
      const token = localStorage.getItem("rcrm_token");
      if (!token) return;
      try {
        const r = await axios.get(`${RB}/leads/search`, { params: { q }, headers: { Authorization: `Bearer ${token}` } });
        setItems(r.data.items || []); setOpen(true); setHi(0);
      } catch { setItems([]); }
    }, 220);
    return () => clearTimeout(t);
  }, [q]);
  useEffect(() => {
    const h = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h); return () => document.removeEventListener("mousedown", h);
  }, []);
  const pick = (l) => { setOpen(false); setQ(""); navigate(leadLink(localStorage.getItem("rcrm_role") || "", l.id)); };
  const onKey = (e) => {
    if (!open || items.length === 0) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setHi((h) => Math.min(h + 1, items.length - 1)); }
    if (e.key === "ArrowUp") { e.preventDefault(); setHi((h) => Math.max(h - 1, 0)); }
    if (e.key === "Enter") { e.preventDefault(); pick(items[hi]); }
    if (e.key === "Escape") setOpen(false);
  };
  return (
    <div ref={box} className="relative hidden lg:block">
      <Search size={14} className="absolute left-2.5 top-2 text-white/70 pointer-events-none" />
      <input data-testid="lead-search-input" value={q} onChange={(e) => setQ(e.target.value)} onFocus={() => items.length && setOpen(true)} onKeyDown={onKey}
        placeholder="Search lead · name or phone" className="w-52 lg:w-64 text-xs rounded-lg bg-white/15 text-white placeholder-white/60 border border-white/25 pl-8 pr-2 py-1.5 focus:outline-none focus:bg-white/25" />
      {open && q.trim().length >= 2 && (
        <div data-testid="lead-search-results" className="absolute right-0 mt-1 w-80 bg-white rounded-xl shadow-xl border border-[#EEE4DA] overflow-hidden z-50 text-[#1A1A2E]">
          {items.length === 0 ? <div className="px-3 py-3 text-xs text-gray-500" data-testid="lead-search-empty">No lead matches "{q}"</div> : items.map((l, i) => (
            <button key={l.id} data-testid={`lead-search-item-${l.id}`} onMouseEnter={() => setHi(i)} onClick={() => pick(l)}
              className={`w-full text-left px-3 py-2 flex items-center justify-between gap-2 ${i === hi ? "bg-[#FFF3E9]" : ""}`}>
              <span className="min-w-0"><span className="block text-sm font-semibold truncate">{l.student_name}</span>
                <span className="block text-[11px] text-gray-500 truncate">{l.phone}{l.class ? ` · Class ${l.class}` : ""}{l.owner_name ? ` · ${l.owner_name}` : ""}</span></span>
              <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-[#F3ECE5] text-[#9A3412] whitespace-nowrap">{l.stage}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
